<template>
    <div class="card card-custom gutter-b">
        <div class="card-body">
            <!--begin::Top-->
            <div class="d-flex">
                <!--begin::Pic-->
                <div class="flex-shrink-0 mr-7">
                    <div class="symbol symbol-50 symbol-lg-120">
                        <b-img
                            v-bind:src="account.profilepic"
                            rounded
                            fluid
                            v-bind:alt="account.username"
                        ></b-img>
                    </div>
                </div>
                <!--end::Pic-->
                <!--begin: Info-->
                <div class="flex-grow-1">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
                        <!--begin::User-->
                        <div class="mr-3">
                            <!--begin::Name-->
                            <a
                                :href="'https://instagram.com/' + account.username"
                                target="_blank"
                                class="
                                    d-flex
                                    align-items-center
                                    text-dark text-hover-primary
                                    font-size-h5 font-weight-bold
                                    mr-3
                                "
                            >
                                {{ account.username }}
                                <i
                                    class="flaticon2-correct text-primary icon-md ml-2"
                                    alt="Verified account"
                                    v-if="account.is_verified"
                                ></i>
                                <i
                                    class="fas fa-dollar-sign text-success icon-md ml-2"
                                    alt="Business account"
                                    v-if="account.is_business_account"
                                ></i>
                                <i
                                    class="fas fa-user-lock text-warning icon-md ml-2"
                                    alt="Private account"
                                    v-if="account.is_private"
                                ></i>
                            </a>
                            <!--end::Name-->
                            <!--begin::Contacts-->
                            <div class="d-flex flex-wrap my-2">
                                <a
                                    v-if="account.business_category_name"
                                    class="
                                        text-muted text-hover-primary
                                        font-weight-bold
                                        mr-lg-8 mr-5
                                        mb-lg-0 mb-2
                                    "
                                >
                                    <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                        <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Mail-notification.svg-->
                                        <i class="flaticon2-placeholder"></i>
                                        <!--end::Svg Icon-->
                                    </span>
                                    <span v-if="account.business_category_name"
                                        >{{ account.business_category_name }}
                                    </span>
                                </a>
                                <template v-if="!isPremium">
                                    <a
                                        v-if="account.lastscanhoursago"
                                        class="
                                            text-muted text-hover-primary
                                            font-weight-bold
                                            mr-lg-8 mr-5
                                            mb-lg-0 mb-2
                                        "
                                    >
                                        <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                            <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Mail-notification.svg-->
                                            <i class="flaticon-clock-2"></i>
                                            <!--end::Svg Icon--> </span
                                        ><span v-if="account.lastscanhoursago"
                                            >Last scanned {{ account.lastscanhoursago }} hours
                                            ago</span
                                        >
                                    </a>
                                </template>
                            </div>
                            <!--end::Contacts-->
                        </div>
                        <!--begin::User-->

                        <!--begin::Actions-->
                        <slot name="actions"></slot>
                        <!--end::Actions-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Content-->
                    <div class="d-flex align-items-center flex-wrap justify-content-between">
                        <!--begin::Description-->
                        <div
                            class="
                                flex-grow-1
                                font-weight-bold
                                text-dark-50
                                py-2 py-lg-2
                                mr-5
                                account-bio
                            "
                        >
                            {{ account.bio }}
                        </div>
                        <div
                            class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5"
                            v-if="account.external_url"
                        >
                            <a
                                class="btn btn-outline-primary btn-sm"
                                target="_blank"
                                v-bind:href="account.external_url"
                            >
                                <i class="fas fa-external-link-alt"></i> View website
                            </a>
                        </div>
                        <!--end::Description-->
                    </div>
                    <!--end::Content-->
                </div>
                <!--end::Info-->
            </div>
            <!--end::Top-->
            <!--begin::Separator-->
            <div class="separator separator-solid my-7"></div>
            <!--end::Separator-->
            <!--begin::Bottom-->
            <div class="d-flex align-items-center flex-wrap">
                <!--begin: Item-->
                <!-- NOTE - Old one was this <div class="d-flex align-items-center flex-lg-fill mr-5 my-1"> -->
                <div class="d-flex align-items-center flex-lg-fill my-5 col-6 col-md-3">
                    <span class="mr-4">
                        <i class="fas fa-images fa-3x"></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                        <span class="font-weight-bolder font-size-sm">Posts</span>
                        <span class="font-weight-bolder font-size-h5">{{
                            addCommaToNumber(account.postcount)
                        }}</span>
                    </div>
                </div>
                <!--end: Item-->
                <!--begin: Item-->
                <div class="d-flex align-items-center flex-lg-fill my-5 col-6 col-md-3">
                    <span class="mr-4">
                        <i class="fas fa-users fa-3x" style="font-weight: 600"></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                        <span class="font-weight-bolder font-size-sm">Followers</span>
                        <span class="font-weight-bolder font-size-h5">
                            {{ addCommaToNumber(account.followers) }}
                        </span>
                    </div>
                </div>
                <!--end: Item-->
                <!--begin: Item-->
                <div class="d-flex align-items-center flex-lg-fill my-5 col-6 col-md-3">
                    <span class="mr-4">
                        <i class="fas fa-user-friends fa-3x" style="font-weight: 600"></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                        <span class="font-weight-bolder font-size-sm">Followings</span>
                        <span class="font-weight-bolder font-size-h5">{{
                            addCommaToNumber(account.followings)
                        }}</span>
                    </div>
                </div>
                <!--end: Item-->
                <!--begin: Item-->
                <div class="d-flex align-items-center flex-lg-fill my-5 col-6 col-md-3">
                    <span class="mr-4">
                        <i class="fas fa-chart-pie fa-3x" style="font-weight: 600"></i>
                    </span>
                    <div class="d-flex flex-column flex-lg-fill">
                        <span class="text-dark-75 font-weight-bolder font-size-sm">Engagement</span>
                        <span class="font-weight-bolder font-size-h5"
                            >{{ account.engagement }}%</span
                        >
                    </div>
                </div>
                <!--end: Item-->
            </div>
            <!--end::Bottom-->
        </div>
    </div>
</template>
<style scoped>
.account-bio {
    white-space: pre-line;
    width: 100%;
}
</style>
<script>
import stringManagement from "@/mixins/stringManagement";
import { mapGetters, mapActions } from "vuex";
export default {
    name: "AccountBadgeWide",
    props: ["account"],
    mixins: [stringManagement],
    computed: {
        ...mapGetters({
            // currentUser: "auth/currentUser",
            isPremium: "auth/isPremium",
            // isEnterprise: "auth/isEnterprise",
        }),
    },
};
</script>
